import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'
// import PropTypes from 'prop-types'
import Logo from './Logo'
import Socials from './Socials'
import bemClass from './../../utils/bemClass'

import './Header.css'

const cn = bemClass('Header')

class Header extends PureComponent {
    render() {
        return (
            <div className={cn()}>
                <Socials className={cn('side-item')} />
                <Link to="/">
                    <Logo className={cn('logo')}/>
                </Link>
                <div className={cn('side-item')} />
            </div>
        )
    }
}

Header.propTypes = {}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx